// extracted by mini-css-extract-plugin
export var fileUpload = "_eh-1";
export var modalButton = "_eh-0";